import GImage from './GImage.vue'
const imageOp = {
  install: (Vue) => {
    Vue.component('GImage', GImage)
  }
}
export default imageOp


